(() => {
  if (customElements.get('gf-premium-school-teams')) return;
  const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const syncCollectionLinks = () => document.querySelectorAll('[data-school-collection-link]').forEach((link) => {
    const target = document.getElementById(link.dataset.anchor);
    const href = target ? `#${link.dataset.anchor}` : link.dataset.fallback;
    link.hidden = !href;
    if (href) link.setAttribute('href', href);
  });

  class PremiumSchoolTeams extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = Array.from(this.querySelectorAll('[data-school-team]'));
      this.search = this.querySelector('[data-school-search]');
      this.filters = this.querySelector('[data-school-filters]');
      this.result = this.querySelector('[data-school-results]');
      this.empty = this.querySelector('[data-school-no-results]');
      this.selectedSeason = '';
      if (!this.search || !this.filters || !this.result || !this.empty) return;
      this.search.value = '';
      this.filters.querySelectorAll('[data-school-generated]').forEach((button) => button.remove());
      const seasons = [...new Set(this.cards.map((card) => card.dataset.season).filter(Boolean))].sort((a, b) => a.localeCompare(b));
      // Season values come only from real collection metadata; no sport-to-season guessing.
      seasons.forEach((season) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.schoolSeason = season;
        button.dataset.schoolGenerated = '';
        button.setAttribute('aria-pressed', 'false');
        button.textContent = season;
        this.filters.append(button);
      });
      this.querySelector('[data-school-tools]').hidden = this.cards.length < 2;
      this.filters.hidden = seasons.length === 0;
      this.querySelector('[data-school-results-row]').hidden = this.cards.length < 2;
      this.search.addEventListener('input', () => this.update(), { signal });
      this.filters.addEventListener('click', (event) => {
        const button = event.target.closest('[data-school-season]');
        if (!button || !this.filters.contains(button)) return;
        this.selectedSeason = button.dataset.schoolSeason;
        this.update();
      }, { signal });
      this.querySelectorAll('[data-school-reset]').forEach((button) => button.addEventListener('click', () => {
        this.search.value = '';
        this.selectedSeason = '';
        this.update();
        this.search.focus();
      }, { signal }));
      this.update();
      requestAnimationFrame(syncCollectionLinks);
    }

    update() {
      const words = normalize(this.search.value).split(/\s+/).filter(Boolean);
      let matches = 0;
      this.cards.forEach((card) => {
        const searchText = normalize(card.dataset.search || '');
        const visible = (!this.selectedSeason || card.dataset.season === this.selectedSeason) && words.every((word) => searchText.includes(word));
        card.hidden = !visible;
        if (visible) matches += 1;
      });
      this.filters.querySelectorAll('[data-school-season]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.schoolSeason === this.selectedSeason)));
      const active = words.length > 0 || this.selectedSeason !== '';
      this.result.textContent = active ? `${matches} of ${this.cards.length} team stores shown` : `Showing all ${this.cards.length} team store${this.cards.length === 1 ? '' : 's'}`;
      this.empty.hidden = matches > 0 || this.cards.length === 0;
      this.querySelector('[data-school-results-row] [data-school-reset]').hidden = !active;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('gf-premium-school-teams', PremiumSchoolTeams);
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(syncCollectionLinks));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncCollectionLinks));
})();
